import React, { createContext, useContext } from "react";
import { Box, Grid } from "@mui/material";
import { Products, Actions, Cart, Checkout } from "./";
import { Route, Routes, useNavigate } from "react-router-dom";
import { useState } from "react";
import ThermalPrinterRecept from "./printReceipt/ThermalPrinterRecept";
import { Alert, Dialog } from "../../layout";
import { useEffect } from "react";
import CashInDrawer from "./CashInDrawer";
import { AppContext } from "../../App";
import { useTranslation } from "react-i18next";
import GeneralPrinterReceipt from "./printReceipt/GeneralPrinterReceipt";
import RegClosingAlert from "./closeRegister/RegClosingAlert";
import { action, controller, Server } from "../../api/Server";
import moment from "moment";

export const CartContext = createContext({});

const Pos = () => {
  const { settings, setPageTitle, selStore } = useContext(AppContext);
  const { t } = useTranslation();
  const [openReg, setOpenReg] = useState({});
  const [editSale, setEditSale] = useState({});
  const [cartItems, setCartItems] = useState([]);
  const [subTotal, setSubTotal] = useState(0);
  const [totalPay, setTotalPay] = useState(0);
  const [tax, setTax] = useState(0);
  const [taxPct, setTaxPct] = useState(0);
  const [receptData, setReceptData] = useState({});
  const [showOpenRegForm, setShowOpenRegForm] = useState(false);
  const [regClosingAlert, setRegClosingAlert] = useState(false);
  const [quote, setQuote] = useState();
  const [alert, setAlert] = useState({
    isOpen: false,
    type: "",
    title: "",
    subTitle: "",
  });
  const navigate = useNavigate();

  const handleClearCart = () => {
    setCartItems([]);
    setSubTotal(0);
    setTotalPay(0);
    setTax(0);
    setReceptData(0);
    settings.store ? setTaxPct(settings.store.tax) : setTaxPct(0);
    setQuote();
    setEditSale({});
    navigate("/pos");
  };

  useEffect(() => {
    handleClearCart();
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selStore]);

  useEffect(() => {
    setPageTitle && setPageTitle(t("pos"));
    settings.store ? setTaxPct(settings.store.tax) : setTax(0);
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [settings]);

  // -------- Register opening check --------
  useEffect(() => {
    if (selStore > 0)
      Server(controller.Register + action.GetActiveReg).getById(
        selStore,
        (res) => {
          if (res.status === 200) {
            var val = res.result;
            setOpenReg({ ...val });
            if (!moment.utc(val.openTime).local().isSame(moment.utc(), "day"))
              setRegClosingAlert(true);
            else setRegClosingAlert(false);
          } else setShowOpenRegForm(true);
        }
      );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selStore]);

  // Edit Sale Process;
  useEffect(() => {
    var sellId = localStorage.getItem("sellId");
    if (sellId) {
      Server(controller.Sell + action.GetEditSale).getById(sellId, (res) => {
        if (res && res.status === 200) {
          setCartItems([...res.cartItems]);
          setEditSale({ ...res.sell });
        } else console.error("error: ", res?.msg);
      });
    }
    return () => {};
  }, []);

  // QuoteSale Process;
  useEffect(() => {
    var quoteId = localStorage.getItem("quoteId");
    if (quoteId) {
      Server(controller.QuoteSale + action.ContinueSale).getById(
        quoteId,
        (res) => {
          if (res && res.status === 200) {
            setCartItems([...res.cartItems]);
            var quote = res.quote;
            setTax(quote.tax || 0);
            setTaxPct(quote.taxPct || 0);
            setQuote({ ...quote });
            localStorage.removeItem("quoteId");
          } else console.error("error: ", res?.msg);
        }
      );
    }
    return () => {};
  }, []);

  return (
    <CartContext.Provider
      value={{
        editSale,
        setEditSale,
        quote,
        setQuote,
        cartItems,
        setCartItems,
        tax,
        setReceptData,
        handleClearCart,
        setAlert,
      }}
    >
      <Box className="d-none" id="printSellRecept">
        {settings && settings.store && settings.store.receiptType === 2 ? (
          <GeneralPrinterReceipt data={receptData} />
        ) : (
          <ThermalPrinterRecept data={receptData} />
        )}
      </Box>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} xl={6} sx={{ paddingTop: "0" }}>
          {regClosingAlert && <RegClosingAlert {...{ openReg }} />}

          {/* Body */}
          <Box
            sx={{
              height: `calc(100vh - ${regClosingAlert ? "410px" : "185px"})`,
              overflow: "auto",
              borderRadius: "0.8rem",
            }}
          >
            <Routes>
              <Route
                path="checkout"
                element={
                  <Checkout
                    {...{
                      subTotal,
                      cartItems,
                      totalPay,
                      setTotalPay,
                      tax,
                      setReceptData,
                      handleClearCart,
                      setAlert,
                      setTax,
                      setTaxPct,
                    }}
                  />
                }
              />
              <Route path="products">
                <Route
                  path=":catId"
                  element={
                    <Products {...{ cartItems, setCartItems, setAlert }} />
                  }
                />
                <Route
                  path=""
                  element={<Products {...{ cartItems, setCartItems }} />}
                />
              </Route>
              <Route
                index
                element={<Products {...{ cartItems, setCartItems }} />}
              />
            </Routes>
          </Box>

          {/* Actions */}
          <Actions
            {...{
              setReceptData,
              setAlert,
              cartItems,
              subTotal,
              tax,
              handleClearCart,
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6} xl={6}>
          <Cart
            {...{
              cartItems,
              setCartItems,
              subTotal,
              setSubTotal,
              setTotalPay,
              setTax,
              taxPct,
            }}
          />
        </Grid>
      </Grid>

      {/* Edit Dialog */}
      {showOpenRegForm && (
        <Dialog show={showOpenRegForm} onClose={false} maxWidth="xs">
          <CashInDrawer {...{ setShow: setShowOpenRegForm }} />
        </Dialog>
      )}
      {/* Alert  */}
      <Alert alert={alert} setAlert={setAlert} />
    </CartContext.Provider>
  );
};

export default Pos;
